import React from "react";
import { ToastContentProps } from "react-toastify";
import Icon from "../icon/Icon";

interface ToastData {
  message: string;
}

const CustomToast: React.FC<ToastContentProps> = (
  props,
): React.ReactElement => {
  const { closeToast, data, toastProps } = props;

  const typedData = data as ToastData;

  const contextClass = {
    success: "bg-success",
    error: "bg-red-600",
    info: "bg-gray-600",
    warning: "bg-orange-400",
    default: "bg-indigo-600",
    dark: "bg-white-600 font-gray-300",
  };

  return (
    <div
      className={`flex max-w-[680px] flex-1 flex-row items-center rounded-lg p-3 ${contextClass[toastProps.type]}`}
    >
      <p className="flex-1 text-[15px]/[24px] font-medium tracking-[-0.15px]">
        {typedData.message}
      </p>
      <Icon name="close" onClick={() => closeToast()} className="ml-3" />
    </div>
  );
};

export default CustomToast;
